import { gql } from 'graphql-tag'

import { USER_CARD_USER } from '@/components/Series/Banners/BreakoutSessionBanner/internal/UserCard.hasura'

export const REGISTRATION_CARD_SESSION_REGISTRATION = gql`
    fragment RegistrationCardSessionRegistration on session_registration {
        id
        attempted_joining
        session_breakout_id
        user {
            id
            virtual_display_name
            ...UserCardUser
        }
    }

    ${USER_CARD_USER}
`
